module.exports = __webpack_public_path__ + "img/DNARepair-PDAC_GSE205354.64d2d137.png";